import { createBrowserRouter } from 'react-router';
import { PaginaErro, PaginaNaoEncontrada } from './PaginasDeErro';
import { RotaProtegida } from './RotaProtegida';
import { Shell } from './layout/Shell';
import {
  rotasProtegidas as rotasAuthProtegidas,
  rotasProtegidasSemMenu as rotasAuthSemMenu,
  rotasPublicas as rotasAuth,
} from '@/features/auth/rotas';
import { rotas as rotasAgenda } from '@/features/agenda/rotas';
import { rotas as rotasAnaliseFinanceira } from '@/features/analise-financeira/rotas';
import { rotas as rotasInicio } from '@/features/inicio/rotas';
import { rotas as rotasLeads } from '@/features/leads/rotas';
import { rotas as rotasMmHays } from '@/features/mm-hays/rotas';
import { rotas as rotasPessoas } from '@/features/pessoas/rotas';
import { rotas as rotasPlanoEstrategico } from '@/features/plano-estrategico/rotas';
import { rotas as rotasProvedores } from '@/features/provedores/rotas';
import { rotas as rotasUsuarios } from '@/features/usuarios/rotas';

/**
 * Raiz do roteador: **só agrega** os `rotas.tsx` de cada feature (docs/CONVENCOES-UI.md).
 * Nunca escreva uma rota de domínio aqui; ela pertence ao `rotas.tsx` da sua feature.
 *
 * Dois níveis: as telas de entrada de `auth` são públicas e ficam **fora** da `Shell` (quem não
 * entrou não tem menu); tudo o mais fica sob `RotaProtegida` → `Shell`. A `RotaProtegida` segura a
 * decisão enquanto a sessão está sendo restaurada, então o F5 numa rota interna não cai no login.
 *
 * `errorElement` na raiz protegida: erro de render em qualquer tela cai na `PaginaErro`, não na tela
 * branca.
 */
export const roteador = createBrowserRouter([
  {
    // As públicas também carregam sob demanda (1.12): se o pedaço de uma delas não chegar — um deploy
    // trocou o nome do arquivo com a aba aberta —, a `PaginaErro` oferece recarregar em vez da tela de
    // erro crua do roteador.
    errorElement: <PaginaErro />,
    children: rotasAuth,
  },
  {
    element: <RotaProtegida />,
    errorElement: <PaginaErro />,
    children: [
      // Protegidas sem Shell: a tela bloqueante da senha nova obrigatória (1.8).
      ...rotasAuthSemMenu,
      {
        path: '/',
        element: <Shell />,
        children: [
          ...rotasInicio,
          ...rotasPlanoEstrategico,
          ...rotasPessoas,
          ...rotasLeads,
          ...rotasAnaliseFinanceira,
          ...rotasProvedores,
          ...rotasAgenda,
          ...rotasMmHays,
          ...rotasAuthProtegidas,
          ...rotasUsuarios,
          /*
           * Endereço desconhecido: 404 desenhada **dentro** da Shell, com menu, em vez de um
           * redirecionamento silencioso para `/` que deixaria a pessoa sem saber que o link
           * estava errado.
           */
          { path: '*', element: <PaginaNaoEncontrada /> },
        ],
      },
    ],
  },
]);
